import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { paymentStatusLookUp } from '@app/core/_constant/new-sales-report.constants';

@Component({
  selector: 'filter-payment-status',
  templateUrl: './filter-payment-status.component.html',
  styleUrls: ['./filter-payment-status.component.scss'],
})
export class FilterPaymentStatusComponent implements OnInit {
  @Input()
  value :number[] | string | number;

  @Input()
  label :string;

  @Input()
  options ?:{ multi ?:boolean } = { multi: true };

  @Output()
  changeStatus :EventEmitter<number[] | number | string> = new EventEmitter<
    number[]
  >();

  statuses :{ label :string; value :number }[] = paymentStatusLookUp;

  constructor() {}

  ngOnInit() :void {}

  onChange() :void {
    this.changeStatus.emit(this.value);
  }
}
